import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { Subject } from 'rxjs';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { ProductosService } from 'src/app/services/productos.service';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-paquetes',
  templateUrl: './paquetes.component.html',
  styleUrls: ['./paquetes.component.scss']
})

export class PaquetesComponent implements OnInit {
  environment = environment.BASE_URL

  paquetes;
  formulario;
  formularioEdit;
  data;
  datosPaquete;
  detallePaquete;
  paqueteid;
  imagenActual;

  respuestaPaquetes: any;
  respuestaAgregarPaquete: any;
  respuestaEditarPaquete: any;
  respuestaUpdatePaquete: any;
  respuestaAgregarProducto:any;
  respuestaDetallePaquete:any;
  respuestaProductos: any;
  respuestaEliminarProducto: any;
  productos;
  categorias;

  tiposPaquete:any;
  categoriasSeleccionadas:any = [];

  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(private _getPaquetes: PaquetesService, private modalService: NgbModal, private _agregarPaquete: PaquetesService,
    private iziToast: Ng2IzitoastService, private _editarPaquete: PaquetesService, private _updatePaquete: PaquetesService,
    private _agregarProductoPaquete:PaquetesService, private _getDetallePaquete: PaquetesService,
    private _getProductos: ProductosService, private _eliminarProductoPaquete: PaquetesService) { }

  ngOnInit(): void {
    this.getPaquetes();
    this.getProductos();
    this.getCategorias();
    this.getTiposPaquete();
    this.formulario = {
      'nombre':'',
      'categoria': '',
      'tipo_paquete': '',
    }

    this.formularioEdit = {
      'nombre':'',
      'categoria':'',
      'tipo_paquete': '',
      'imagen':'',
      'marco':'',
      'color_marco':'',
      'placa':'', 
      'color_placa':'',
      'diploma':'',
      'agradecimiento':'',
      'diploma_agradecimiento':'',
      'texto':'',
      'anillo':'',
      'personalizador':'',
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      pageLength: 20,
      processing: true
    };
  }

  getPaquetes(){
    this._getPaquetes.getPaquetes().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.paquetes = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getCategorias(){
    this._getPaquetes.getCategorias().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.categorias = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getTiposPaquete(){
    this._getPaquetes.getTiposPaquete().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.tiposPaquete = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
    // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  agregarPaquete(){
    // this.data = {
    //   'nombre': this.formulario.nombre,
    // }

    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('precio', this.formulario.precio);
    // formData.append('categorias', this.categoriasSeleccionadas);
    formData.append('categoria', this.formulario.categoria);
    
    formData.append('tipo_paquete', this.formulario.tipo_paquete);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }

    this._agregarPaquete.agregarPaquete(formData).subscribe(
      data => {
        this.respuestaAgregarPaquete = data;
        if(this.respuestaAgregarPaquete.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getPaquetes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }

  editarPaquete(paquete){
    this.data = {
      'paquete':paquete,
    }
    this._editarPaquete.editarPaquete(this.data).subscribe(
      data => {
        this.respuestaEditarPaquete = data;
        if(this.respuestaEditarPaquete.success){
          this.datosPaquete = this.respuestaEditarPaquete.content;
          this.formularioEdit.nombre = this.datosPaquete.nombre;
          this.formularioEdit.precio = this.datosPaquete.precio;
          this.formularioEdit.categoria = this.datosPaquete.categoria;
          this.formularioEdit.tipo_paquete = this.datosPaquete.tipo_paquete;
          this.formularioEdit.marco = this.datosPaquete.marco;
          this.formularioEdit.color_marco = this.datosPaquete.color_marco;
          this.formularioEdit.placa = this.datosPaquete.placa;
          this.formularioEdit.color_placa = this.datosPaquete.color_placa;
          this.formularioEdit.diploma = this.datosPaquete.diploma;
          this.formularioEdit.agradecimiento = this.datosPaquete.agradecimiento;
          this.formularioEdit.diploma_agradecimiento = this.datosPaquete.diploma_agradecimiento;
          this.formularioEdit.texto = this.datosPaquete.texto;
          this.formularioEdit.anillo = this.datosPaquete.anillo;
          this.formularioEdit.personalizador = this.datosPaquete.personalizador;
          this.imagenActual = this.datosPaquete.imagen;
          this.paqueteid = paquete;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updatePaquete(paquete){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('precio', this.formularioEdit.precio);
    formData.append('categoria', this.formularioEdit.categoria);
    formData.append('tipo_paquete', this.formularioEdit.tipo_paquete);
    formData.append('marco', this.formularioEdit.marco);
    formData.append('color_marco', this.formularioEdit.color_marco);
    formData.append('placa', this.formularioEdit.placa);
    formData.append('color_placa', this.formularioEdit.color_placa);
    formData.append('diploma', this.formularioEdit.diploma);
    formData.append('agradecimiento', this.formularioEdit.agradecimiento);
    formData.append('diploma_agradecimiento', this.formularioEdit.diploma_agradecimiento);
    formData.append('texto', this.formularioEdit.texto);
    formData.append('anillo', this.formularioEdit.anillo);
    formData.append('personalizador', this.formularioEdit.personalizador);
    formData.append('paquete', paquete);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }


    this._updatePaquete.updatePaquete(formData).subscribe(
      data => {
        this.respuestaUpdatePaquete = data;
        if(this.respuestaUpdatePaquete.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el cliente correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getPaquetes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getDetallePaquete(paquete){
    this.data = {
      'paquete':paquete
    }

    this._getDetallePaquete.getDetallePaquete(this.data).subscribe(
      data => {
        this.respuestaDetallePaquete = data;
        if(this.respuestaDetallePaquete.success){
          this.detallePaquete = this.respuestaDetallePaquete.content;
          this.paqueteid = paquete;
          document.getElementById('clickPaquete').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getProductos(){
    this._getProductos.getProductos().subscribe(
      data => {
        this.respuestaProductos = data;
        if(this.respuestaProductos.success){
          this.productos = this.respuestaProductos.content;
          console.log(this.productos);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  agregarProductoPaquete(producto, paquete){
    this.data = {
        'paquete':paquete, 
        'producto_final':producto
    }

    this._agregarProductoPaquete.agregarProductoPaquete(this.data).subscribe(
      data => {
        this.respuestaAgregarProducto = data;
        if(this.respuestaAgregarProducto.success){
          this.dismissAll();
          this.getDetallePaquete(paquete);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarProductoPaquete(producto, paquete){
    this.data = {
      'producto':producto
    }

    this._eliminarProductoPaquete.eliminarProductoPaquete(this.data).subscribe(
      data => {
        this.respuestaEliminarProducto = data;
        if(this.respuestaEliminarProducto.success){
          this.dismissAll();
          this.getDetallePaquete(paquete);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  desactivar(paquete){
    this.data = {
      'paquete':paquete
    }

    this._eliminarProductoPaquete.desactivarPaquete(this.data).subscribe(
      data => {
        this.respuestaEliminarProducto = data;
        if(this.respuestaEliminarProducto.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el paquete correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getPaquetes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  activar(paquete){
    this.data = {
      'paquete':paquete
    }

    this._eliminarProductoPaquete.activarPaquete(this.data).subscribe(
      data => {
        this.respuestaEliminarProducto = data;
        if(this.respuestaEliminarProducto.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el paquete correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getPaquetes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  // seleccionarCategoria(categoria:number, event:any){
  //   if (event.target.checked) {
  //     this.categoriasSeleccionadas.push(categoria);
  //   }else{
  //     for(var i = 0; i<this.categoriasSeleccionadas.length; i++){
  //       if(this.categoriasSeleccionadas[i] == categoria){
  //         this.categoriasSeleccionadas.splice(i, 1);
  //       } 
  //     }
  //   }
  // }

  

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
